import Constants from "@husky-hrc/Utilities/Constants";
import { enableHMRForChain } from "@husky-hrc/Utilities/Utilities";
import isApiError from "@insite/client-framework/Common/isApiError";
import { addToChainBefore, addToEndOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { post } from "@insite/client-framework/Services/ApiService";
import { AddWishListLinesApiParameter } from "@insite/client-framework/Services/WishListService";
import {
    AddLineToWishList,
    chain,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";

enableHMRForChain(chain);

type addWishListLineProps = Parameters<typeof AddLineToWishList>[0];

export const HuskyAddLineToWishList = async (props: addWishListLineProps) => {
    if (!props.result.wishList) {
        return;
    }

    try {
        const lines = props.parameter.productInfos.map(productInfo => ({
            productId: productInfo.productId,
            qtyOrdered: productInfo.qtyOrdered,
            unitOfMeasure: productInfo.unitOfMeasure,
        }));
        const toCartId = props.result.wishList.properties.tactonCartId;
        const configId = (props.parameter as any).configId;
        const isComplete = !!(props.parameter as any).isComplete;
        await addWishListLines({ wishList: props.result.wishList, lines, configId, toCartId, isComplete } as any);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.result.errorMessage = error.errorJson.message;
            return;
        }
        if (error?.status === 404) {
            props.result.errorMessage = error.errorMessage;
            return;
        }
        throw error;
    }
};

export function addWishListLines(parameter: AddWishListLinesApiParameter) {
    const wishListLinesUri = parameter.wishList.wishListLinesUri.substr(
        parameter.wishList.wishListLinesUri.indexOf("/api/v1"),
    );
    return post(
        `${wishListLinesUri}/batch?configId=${(parameter as any).configId}&toCartId=${
            (parameter as any).toCartId
        }&isComplete=${(parameter as any).isComplete}`,
        { wishListLines: parameter.lines },
    );
}

export const ResetCartData = (props: addWishListLineProps) => {
    if (!props.result?.errorMessage && props.parameter.onSuccess) {
        props.dispatch({
            type: "Data/Carts/Reset",
        });
    }
};

export const DispatchRemoveProductConfig = (props: addWishListLineProps) => {
    if (props.parameter.productInfos.length === 1) {
        props.dispatch({
            type: Constants.Actions.RemoveProductConfig,
            productId: props.parameter.productInfos[0].productId,
        } as any);
    }
};

replaceInChain(chain, AddLineToWishList, HuskyAddLineToWishList);
addToChainBefore(chain, ExecuteOnSuccessCallback, ResetCartData);
addToEndOfChain(chain, DispatchRemoveProductConfig);
